import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  size: PropTypes.string,
};

const ChromeIcon = ({ size = '32', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Chrome"
    viewBox="0 0 512 512"
    width={size}
    {...props}
  >
    <circle cx="256" cy="256" r="256" fill="#fcc11d" />
    <path d="M34.3 128A256 256 0 0 0 256 512l111-192" fill="#289b48" />
    <path d="M34.3 128a256 256 0 0 1 443.4 0H256L145 320" fill="#e0392c" />
    <circle
      cx="256"
      cy="256"
      r="114.7"
      fill="#1a73e8"
      stroke="#fff"
      strokeWidth="26.7"
    />
  </svg>
);

ChromeIcon.propTypes = propTypes;

export default ChromeIcon;
